
<div class="header">
    <div class="content-logo">
        <div class="logo">
            <h1><a [routerLink]="'home'">ilCorsaronero<span>.</span>it</a></h1>
        </div>
        <div class="sidebarIconToggle" [ngClass]="{'active': menuState}" (click)="openMenuMobile()">
            <div class="spinner diagonal part-1"></div>
            <div class="spinner horizontal"></div>
            <div class="spinner diagonal part-2"></div>
        </div>
    </div>
    <div class="menu">
        <ul>
            <li *ngFor="let item of items">
                <a [routerLink]="item.link" alt="item" [class.disabled]="item.disabled">
                    {{item.name}}
                </a>
            </li>
        </ul>
    </div>
</div>

<!--<div class="typology-cover">
    <div class="typology-cover-item"></div>
</div>-->